@let isDesktop = deviceService.isDesktop$ | async;
@let canGoBack = $canGoBack();
@let isDesktopSidebarOpen = $isDesktopSidebarOpen();
@let isRequestPage = $isRequestPage();

<main>
  @if (isDesktop) {
    <div
      [ngClass]="{
        'desktop-main-layout-borders desktop-width-limit sticky top-0 z-20':
          canGoBack,
      }"
      class="desktop-main-layout-header mx-auto"
    >
      <tui-app-bar class="flex items-center h-full! x-white z-1">
        <section tuiSlot="start" class="flex items-center">
          <button
            tuiIconButton
            iconStart="@tui.menu"
            class="font-extrabold x-text-dark-main me-2 mt-2"
            size="m"
            appearance="outline"
            (click)="toggleSidebar(true)"
          >
            <tui-drawer
              *tuiPopup="isDesktopSidebarOpen"
              class="x-sidebar-drawer"
              direction="start"
              [overlay]="true"
              (click)="
                $event.target === $event.currentTarget && toggleSidebar(false)
              "
            >
              <h1
                class="font-extrabold text-[20px] x-text-dark-main flex items-center cursor-pointer"
                routerLink="."
              >
                <x-svg-icon
                  icon="x-icon::x-keeper-logo"
                  class="me-[2px]"
                ></x-svg-icon>
                Модули
              </h1>
              <nav
                class="min-h-[calc(100dvh-5rem)] flex flex-col justify-center"
              >
                @for (
                  group of navigationService.menuGroups;
                  track group.groupLabel
                ) {
                  @if (
                    group.groupLabel &&
                    navigationService.groupHasVisibleItems(group.items)
                  ) {
                    <p
                      class="mt-4 mb-1 text-xs font-semibold uppercase tracking-wider opacity-50 x-text-dark-main"
                    >
                      {{ 'core.sidebar.' + group.groupLabel | translate }}
                    </p>
                  }
                  @for (item of group.items; track item.label) {
                    @if (
                      permissionService.hasPermission$(item.permission) | async
                    ) {
                      <div
                        [class.pl-2]="group.groupLabel"
                        [class.mb-2]="$last"
                        [title]="'core.sidebar.' + item.label | translate"
                      >
                        <button
                          class="mt-2 x-text-dark-main-important flex items-center"
                          [iconStart]="item.icon"
                          [ngClass]="{
                            'font-bold!':
                              navigationService.isRequestsRouteActive(
                                item.link
                              ),
                          }"
                          [routerLink]="item.link"
                          appearance="flat"
                          size="m"
                          tuiLink
                          (click)="toggleSidebar(false)"
                        >
                          <span
                            class="x-font-body-2"
                            [ngClass]="{
                              'font-bold!':
                                navigationService.isRequestsRouteActive(
                                  item.link
                                ),
                            }"
                          >
                            {{ 'core.sidebar.' + item.label | translate }}
                          </span>
                        </button>
                      </div>
                    }
                  }
                }
              </nav>
            </tui-drawer>
          </button>
          <h1
            class="font-extrabold text-[22px] x-text-dark-main flex items-center cursor-pointer relative"
            routerLink="."
          >
            <x-svg-icon
              icon="x-icon::x-keeper-logo"
              class="me-[2px]"
            ></x-svg-icon>
            Outkeep
          </h1>
          <x-app-version></x-app-version>

          @if (canGoBack) {
            <button
              tuiIconButton
              type="button"
              class="mx-4 x-text-dark-main"
              size="m"
              iconStart="@tui.arrow-left"
              routerLink="."
              appearance="outline"
            ></button>
          }
        </section>

        <h1 class="x-font-body-1-bold">
          {{ $navbarHeader() }}
        </h1>

        <section tuiSlot="end">
          <div class="flex items-center">
            @if (canGoBack && isRequestPage) {
              <x-request-form-change-status-button
                [isMobile]="false"
                class="me-3"
              />
            }
            @if (!canGoBack) {
              <x-pwa-install-button [appearance]="'outline'" class="mx-3" />
            }
            <x-profile>
              @if (canGoBack) {
                <x-pwa-install-button [appearance]="'floating'" />
              }
            </x-profile>
          </div>
        </section>
      </tui-app-bar>
    </div>
  } @else {
    <x-sidebar
      [isMobile]="true"
      [navbarHeader]="$navbarHeader()"
      [canGoBack]="canGoBack"
      [isRequestPage]="isRequestPage"
    >
      <x-pwa-install-button [appearance]="'outline'" />
    </x-sidebar>
  }

  <tui-scrollbar>
    <ng-content></ng-content>
  </tui-scrollbar>
</main>
